// extracted by mini-css-extract-plugin
export var addButton = "_p7-0";
export var border = "_p7-8";
export var check = "_p7-h";
export var danger = "_p7-6";
export var dropdownContainer = "_p7-1";
export var editModalBody = "_p7-j";
export var footerContainer = "_p7-i";
export var fullWidth = "_p7-a";
export var hide = "_p7-9";
export var icon = "_p7-3";
export var input = "_p7-7";
export var inputFlex = "_p7-b";
export var inputWrapper = "_p7-c";
export var manualFocus = "_p7-5";
export var optionButton = "_p7-4";
export var pillWrapper = "_p7-e";
export var pointer = "_p7-2";
export var showOverflow = "_p7-f";
export var tagsFlex = "_p7-d";
export var xButton = "_p7-g";